import { render, staticRenderFns } from "./ContentDialogSelector.vue?vue&type=template&id=aa830f32&scoped=true"
import script from "./ContentDialogSelector.vue?vue&type=script&lang=js"
export * from "./ContentDialogSelector.vue?vue&type=script&lang=js"
import style0 from "./ContentDialogSelector.vue?vue&type=style&index=0&id=aa830f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa830f32",
  null
  
)

export default component.exports